import { useState } from "react";

import { Link } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";

export default function Number_Attendees() {
  const [open, setopen] = useState<boolean>(false);

  return (
    <>
      <Row>
        <Col>
          <Title title="استعلام عدد الحضور" />
        </Col>
      </Row>
      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden  ">
            <thead className=" bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td className="px-1">اسم المقرر </td>
                <td className="px-16"> رمز المقرر </td>
                <td className="px-16">
                  <button className="w-[200px] bg-[#F6F8F9] p-2 rounded-2xl">
                    تصدير كملف اكسل
                  </button>
                </td>
              </tr>
            </thead>
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td className="px-1"> عدد الطلاب الحضور </td>
                <td className="px-1"> اسم القاعة</td>
                <td className="px-1"> استعلام </td>
              </tr>
            </thead>
            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>0000</td>
                <td>اسم القاعة</td>
                <td>
                  {" "}
                  <Link to={"/registered_students"}>
                    <button className="w-[100px] bg-[#efc5e6] p-2 rounded-2xl">
                      استعلام
                    </button>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
